module.exports = __webpack_public_path__ + "img/i_user.1690144e.svg";